import Skeleton from '@discover-ui/skeleton';
import { AvailabilitySectionSkeleton } from '@discover-components/availability/section';
import { AvailabilityChipsSkeleton } from '@discover-components/availability/section/chips';
import { RestaurantRatingSkeleton } from '@discover-components/restaurant/rating';
import { RestaurantCardTitleRowSkeleton } from '@discover-components/restaurant/card/titleRow';
import { RestaurantCardSubtitleRowSkeleton } from '@discover-components/restaurant/card/subtitleRow';
import useIsRowLayout from '@discover-components/availability/hooks/useIsRowLayout';
import RestaurantCardRoot, { type RestaurantCardRootProps } from './root';

export type RestaurantCardSkeletonProps = Omit<RestaurantCardRootProps, 'children'> & {
  discount?: number;
};

export default function RestaurantCardSkeleton({
  discount,
  ...props
}: RestaurantCardSkeletonProps) {
  // Match the loaded card so the layout doesn't jump when data loads.
  const isRowLayout = useIsRowLayout();

  return (
    <RestaurantCardRoot {...props}>
      {/* RestaurantCardImage */}
      <div className="lg:row-span-2">
        <Skeleton className="aspect-square w-32 min-w-full max-w-[29vw] rounded lg:w-[218px] lg:max-w-none" />
      </div>
      <div className="flex flex-col gap-1.5 self-stretch sm:gap-2">
        <RestaurantCardTitleRowSkeleton />
        <RestaurantCardSubtitleRowSkeleton />
        <RestaurantRatingSkeleton className="h-[22px] text-[14px] leading-[20px] md:hidden" />
        <div className="flex flex-col flex-wrap gap-2.5 md:mt-2">
          <div className="flex flex-wrap items-center gap-1">
            <Skeleton as="span" className="h-9 w-28 rounded-xl" />
            <Skeleton as="span" className="h-9 w-[104px] rounded-xl" />
          </div>
          <div className="hidden sm:flex">
            <AvailabilityChipsSkeleton showDiscount={isRowLayout} />
          </div>
        </div>
      </div>
      <div className="col-span-2 flex sm:hidden">
        <AvailabilityChipsSkeleton showDiscount={isRowLayout} />
      </div>
      <div className="col-span-2 lg:col-span-1">
        <AvailabilitySectionSkeleton
          discount={discount}
          direction={isRowLayout ? 'row' : 'column'}
        />
      </div>
    </RestaurantCardRoot>
  );
}
